<header class="ion-header ion-hide-lg-up">
  <header-main></header-main>
</header>

<main class="ion-content tr" fullscreen>
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1>
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.64 27.64"><defs><style>.profile{stroke:none;}</style></defs><title>profile</title><g id="Layer_2" data-name="Layer 2"><g id="icons"><path class="profile" d="M13.82,27.64A13.82,13.82,0,1,1,27.64,13.82,13.84,13.84,0,0,1,13.82,27.64ZM13.82,2A11.82,11.82,0,1,0,25.64,13.82,11.83,11.83,0,0,0,13.82,2Z"/><path class="profile" d="M13.82,16.62c2,0,3.67-2,3.67-4.46S17,7.7,13.82,7.7s-3.67,2-3.67,4.46S11.79,16.62,13.82,16.62Z"/><path class="profile" d="M6.89,23.43c0-.15,0-.05,0,0Z"/><path class="profile" d="M20.75,23.54Z"/><path class="profile" d="M20.74,23.25c-.07-4.29-.63-5.52-4.91-6.29a2.58,2.58,0,0,1-2,.77,2.56,2.56,0,0,1-2-.77c-4.24.77-4.84,2-4.91,6.15,0,.34,0,.36,0,.32v.45s1,2.05,6.93,2.05,6.93-2.05,6.93-2.05v-.34S20.75,23.52,20.74,23.25Z"/></g></g></svg>
      Login
    </h1>
  </header>

  <div class="grid container">
    <div class="row">
      <div class="col col-xs-12 col-sm-6 col-lg-4 col-sm-offset-3 col-lg-offset-4">
        <div class="ion-card ion-padding detail">
          <div class="ion-card-content ion-padding-end ion-padding-start">
            <button *ngIf="isAppleLogin" class="button-large button-round button-tertiary" (click)="signInWithApple()">
              Login with Apple
            </button>
            <button class="button-large button-round button-tertiary" (click)="signInWithGoogle()">
              Login with Gmail
            </button>
            <form *ngIf="loginForm" [formGroup]="loginForm" (submit)="login()" novalidate autocomplete="off" (keyup.enter)="login()">
              <p class="ion-text-center ion-text-primary">
                <small>or Login with Email / Password</small>
              </p>
              <div class="ion-item">
                <label class="ion-label" position="stacked">Email</label>
                <input #email type="email" placeholder="Your email address" formControlName="email" [class.invalid]="!loginForm.get('email')?.valid && loginForm.get('email')?.dirty">
              </div>
              <div *ngIf="(!loginForm.get('email')?.valid && loginForm.get('email')?.dirty)" class="ion-item error-message">
                <p class="ion-text-tertiary">
                  <small><sup>*</sup>Please enter a valid email.</small>
                </p>
              </div>
              <div class="ion-item">
                <a href="/recover">
                  <small class="ion-float-right forgot-password">Forgot?</small>
                </a>
                <label class="ion-label" position="stacked">Password</label>
                <input #password type="password" placeholder="Your password" formControlName="password" [class.invalid]="!loginForm.get('password')?.valid && loginForm.get('password')?.dirty">
              </div>
              <div class="ion-item error-message" *ngIf="(!loginForm.get('password')?.valid && loginForm.get('password')?.dirty)">
                <p class="ion-text-tertiary">
                  <small><sup>*</sup>Password needs more than 6 characters.</small>
                </p>
              </div>
              <button class="button-large button-round button-secondary" type="submit">
                Login
              </button>
            </form>
            <a href="/sign-up">
              <button class="button-large button-round button-clear">
                Create new account?
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
